<div>
  <app-alert></app-alert>
</div>
<app-modal (onOkToParent)='okCloseButtonClick(true)'   (onCloseToParent)='okCloseButtonClick(false)' *ngIf='openModal'
[dialogTitle]="dialogTitle"
[dialogTextLine1]="dialogTextLine1"
[dialogTextLine2]="dialogTextLine2"
[primaryButtonText]="'OK'"
[secondaryButtonText]="cancelButton"
></app-modal>
<div id="dvEmailVerificationHeader" class="emailHeader">
  <p>The following hotels do not have emails assigned to them. Continue if you do not want an email notification to be
    sent only to the properties that don't have an email, or enter an email to send selected notification template for
    the property to be notified.</p>
</div>

<div id="emailGrid" class="emailGrid">
  <kendo-grid [data]="gridView" [pageSize]="pageSize" [skip]="skip" [pageable]="true" (pageChange)="pageChange($event)"
    [resizable]="true" id="grid">
    <kendo-grid-column id="hotelColumn" field="PropertyName" title="Hotel Name">
      <ng-template kendoGridHeaderTemplate let-column>
        <span id="hotelColumnTitle">{{column.title}} </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column id="idColumn" field="HotelCRSPropertyCode" title="Lanyon ID" [width]="135">
      <ng-template kendoGridHeaderTemplate let-column>
        <span id="idColumnTitle">{{column.title}} </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column id="addressColumn" field="PropertyAddress" title="Address">
      <ng-template kendoGridHeaderTemplate let-column>
        <span id="addressColumnTitle">{{column.title}} </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column id="stateColumn" field="PropertyStateProvince" title="State" [width]="135">
      <ng-template kendoGridHeaderTemplate let-column>
        <span id="stateColumnTitle">{{column.title}} </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column id="cityColumn" field="PropertyCity" title="City" [width]="150">
      <ng-template kendoGridHeaderTemplate let-column>
        <span id="cityColumnTitle">{{column.title}} </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column id="countryColumn" field="PropertyCountry" title="Country" [width]="150">
      <ng-template kendoGridHeaderTemplate let-column>
        <span id="countryColumnTitle">{{column.title}} </span>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column id="emailColumn" field="ContactEMail" title="E-mail">
      <ng-template kendoGridHeaderTemplate let-column>
        <span>{{column.title}} </span>
        <span class="cvt-icon-information grid-cmd-icons" title="Separate multiple emails with a semicolon"></span>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        <input id="txtEmail" [class]="getClassStr(dataItem.ContactEMail)" type="text" style="width:100%" [(ngModel)]="dataItem.ContactEMail"
          (keyup.enter)="onEmailChange(dataItem)" (blur)="onEmailChange(dataItem)">
      </ng-template>
    </kendo-grid-column>
    <ng-template kendoGridNoRecordsTemplate>
      All properties have an associated email
    </ng-template>
  </kendo-grid>
</div>